<template>
  <div class="flex flex-col h-screen">
    <component :is="layout">
      <RouterView v-slot="{ Component }">
        <template v-if="Component">
          <Suspense>
            <component :is="Component" />
            <template #fallback>Loading...</template>
          </Suspense>
        </template>
      </RouterView>
    </component>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useLsGeneralStore } from './stores/application'
import { computed } from 'vue'

const route = useRoute()
const store = useLsGeneralStore()
const router = useRouter()

const layout = computed(() => route.meta.layout || 'div')

store.$subscribe((_, state) => {
  if (state.jwt === null) {
    if (!route.meta.public) {
      router.push({ name: 'login' })
    }
  }
})
</script>
